import { H1, P } from "#common/headings";
import { Grid } from "@mui/material";
import { nlExamples } from "#pages/landing/QueryExamples";
import LinkCard from "#components/LinkCard";
import * as React from "react";
import { useAppSelector } from "#store";
import { Todo } from "#common/Todo";

export const NlExamplesChooser = ({
    onSubmit,
}: {
    onSubmit: (input: string) => void;
}) => {
    const currentDs = useAppSelector(state => state.uiState.selectedDatasource);
    return (
        <>
            <Grid item xs={12}>
                <H1>Explore {currentDs.label} by natural language</H1>
                <P></P>
            </Grid>
            <Grid item xs={12} container spacing={4} sx={{ marginTop: "1rem" }}>
                {nlExamples
                    .filter(x => x.db === currentDs.name)
                    .map(({ nl, db, ql = "" }, index) => {
                        return (
                            <Grid item xs={12} md={4} lg={3} key={nl + db}>
                                <LinkCard
                                    action={() => onSubmit(nl)}
                                    title={nl}
                                    text={""}
                                    actionText={"Run this query"}
                                />
                            </Grid>
                        );
                    })}
                {nlExamples.filter(x => x.db === currentDs.name).length ===
                0 ? (
                    <Grid item xs={12} md={4} lg={3} key={"no-examples"}>
                        <P>
                            <Todo>Add examples</Todo>
                        </P>
                    </Grid>
                ) : null}
            </Grid>
        </>
    );
};
